<ion-segment
  *ngIf="showSegments"
  [class.is-in-two-columns]="isSettingUpAutopay"
  data-cy="bank-account-toggle"
  mode="ios"
  [value]="selectedSegment"
  (ionChange)="setSelectedSegment($event)"
>
  <ion-segment-button
    data-cy="existing-account-toggle"
    [value]="toggleOptions.existingAccount"
  >
    <ion-label data-cy="existing-account-toggle-text">
      {{ 'i18n.payments.addBankAccountModal.existingAccount' | translate }}
    </ion-label>
  </ion-segment-button>
  <ion-segment-button
    data-cy="new-account-toggle"
    [value]="toggleOptions.newAccount"
  >
    <ion-label data-cy="new-account-toggle-text">
      {{ 'i18n.payments.addBankAccountModal.newAccount' | translate }}
    </ion-label>
  </ion-segment-button>
</ion-segment>
<app-add-bank-account-form
  *ngIf="selectedSegment === toggleOptions.newAccount; else existingAccount"
  [addBankAccountForm]="addBankAccountForm"
  [showNickNameField]="
    showSegments ||
    canSelectCustomers ||
    isEditingAutopay ||
    isEditingBankAccount
  "
  [canSelectCustomers]="canSelectCustomers"
  [selectedCustomers]="selectedCustomers"
  [showIsPrimaryField]="!isSettingUpAutopay && !isEditingAutopay"
  [showRoutingNumberField]="!isEditingAutopay && !isEditingBankAccount"
  [isDesktop]="isDesktop"
  [canModifyForm]="canModifyForm"
  [isBankRoutingValidationOn]="isBankRoutingValidationOn"
  (isLoadingEmit)="isFormLoading($event)"
  (submitEmit)="submitForm()"
></app-add-bank-account-form>

<ng-template #existingAccount>
  <div
    *ngIf="isPrimaryByDefault && bankAccounts.length > 0"
    data-cy="heads-up-primary-account"
    class="heads-up"
  >
    <div>
      <ion-icon name="alert-circle-outline"></ion-icon>
    </div>
    <div
      [innerHTML]="
        'i18n.payments.addBankAccountModal.defaultPrimaryAccountMsg' | translate
      "
    ></div>
  </div>
  <app-bank-account-list
    [isSettingUpAutopay]="isSettingUpAutopay"
    [bankAccounts]="bankAccounts"
    [isDesktop]="isDesktop"
    [bankIdSelected]="selectedBankAccount?.bankID"
    (selectBankAccountEmitter)="selectBankAccount($event)"
  ></app-bank-account-list>
</ng-template>
